export const cartEventsConfig = {
    parentSelector: 'cart-items, .cart__contents, slider-component',
    events: {
        continueShopping: {
            selector: '.title-wrapper-with-link .underlined-link',
            event: {
                event: 'cart',
                component: '',
                element: 'link',
                action: 'click',
                trigger: 'click',
                getDynamicData: (element) => ({
                    link_text: element.textContent.trim(),
                    link_url: element.href
                })
            }
        },
        productName: {
            selector: '.cart-item__name',
            event: {
                event: 'cart',
                component: '',
                element: 'link',
                action: 'click',
                trigger: 'click',
                getDynamicData: (element) => ({
                    field: element.textContent.trim(),
                    link_text: element.textContent.trim(),
                    link_url: element.href
                })
            }
        },
        quantityDecrease: {
            selector: '.quantity__button[name="minus"]',
            event: {
                event: 'cart',
                component: 'item_quantity',
                element: 'icon',
                action: 'click',
                trigger: 'click',
                getDynamicData: (element) => {
                    const cartItem = element.closest('.cart-item');
                    const productName = cartItem?.querySelector('.cart-item__name')?.textContent.trim() || 'unknown';
                    return {
                        field: productName,
                        action_value: 'decrease'
                    };
                }
            }
        },
        quantityIncrease: {
            selector: '.quantity__button[name="plus"]',
            event: {
                event: 'cart',
                component: 'item_quantity',
                element: 'icon',
                action: 'click',
                trigger: 'click',
                getDynamicData: (element) => {
                    const cartItem = element.closest('.cart-item');
                    const productName = cartItem?.querySelector('.cart-item__name')?.textContent.trim() || 'unknown';
                    return {
                        field: productName,
                        action_value: 'increase'
                    };
                }
            }
        },
        quantityInput: {
            selector: '.quantity__input',
            events: {
                focus: {
                    event: 'cart',
                    component: 'item_quantity',
                    element: 'number',
                    action: 'focus',
                    trigger: 'focus',
                    getDynamicData: (element) => {
                        const cartItem = element.closest('.cart-item');
                        const productName = cartItem?.querySelector('.cart-item__name')?.textContent.trim() || 'unknown';
                        return {
                            field: productName
                        };
                    }
                },
                input: {
                    event: 'cart',
                    component: 'item_quantity',
                    element: 'number',
                    action: 'input',
                    trigger: 'input',
                    getDynamicData: (element) => {
                        const cartItem = element.closest('.cart-item');
                        const productName = cartItem?.querySelector('.cart-item__name')?.textContent.trim() || 'unknown';
                        return {
                            field: productName,
                            input_value: element.value
                        };
                    }
                }
            }
        },
        removeProduct: {
            selector: 'a.button.button--tertiary',
            event: {
                event: 'cart',
                component: '',
                element: 'icon',
                action: 'click',
                trigger: 'click',
                getDynamicData: (element) => {
                    const cartItem = element.closest('.cart-item');
                    const nameElement = cartItem?.querySelector('a.cart-item__name');
                    const productName = nameElement ? nameElement.textContent.trim() : 'unknown';
                    return {
                        field: productName,
                        action_value: 'remove'
                    };
                }
            }
        },
        checkoutButton: {
            selector: 'button[name="checkout"], .cart__checkout-button',
            event: {
                event: 'cart',
                component: '',
                element: 'cta_button',
                action: 'click',
                trigger: 'click',
                getDynamicData: (element) => ({
                    click_text: element.textContent.trim(),
                    link_url: element.form?.action || element.closest('a')?.href || (window.location.origin + window.location.pathname + '/checkout')
                })
            }
        },
        productSlider: {
            parentSelector: '.slider-buttons',
            selector: '.slider-button--prev, .slider-button--next, svg.icon.icon-caret',
            event: {
                event: 'cart',
                component: 'product_slider',
                element: 'chevron',
                action: 'click',
                trigger: 'click',
                getDynamicData: (element) => ({
                    action_value: element.classList.contains('slider-button--next') ? 'next' : 'previous'
                })
            }
        },
        productSliderCard: {
            parentSelector: '.complementary-products',
            selector: '.card__heading a',
            event: {
                event: 'cart',
                component: 'product_slider',
                element: 'card',
                action: 'click',
                trigger: 'click',
                getDynamicData: (element) => ({
                    field: element.textContent.trim(),
                    link_url: element.href
                })
            }
        },
        productSliderCTA: {
            selector: 'form[id*="quick-add-"]',
            event: {
                event: 'cart',
                component: 'product_slider',
                element: 'cta_button',
                action: 'click',
                trigger: 'submit',
                getDynamicData: (element) => {
                    const cardWrapper = element.closest('.card-wrapper');
                    const headingLink = cardWrapper?.querySelector('.card__heading a');
                    const productName = headingLink ? headingLink.textContent.trim() : 'unknown';
                    const submitButton = element.querySelector('.quick-add__submit');
                    const clickText = submitButton ? submitButton.textContent.trim() : 'Add to cart';
                    return {
                        field: productName,
                        click_text: clickText
                    };
                }
            }
        }
    }
}; 